import Modal from "./Modal.jsx";
import Button from "./Button.jsx";
import {useTranslation} from "react-i18next";
import LoadingComponent from "./LoadingComponent.jsx";

export default function YesNo({visible, setVisible, title, question, onYes, onNo, loading, dangerous = true}) {

    let {t} = useTranslation();

    let yesPressed = () => {
        if (onYes) {
            onYes();
        }
        setVisible(false);
    };

    let noPressed = () => {
        if (onNo) {
            onNo();
        }
        setVisible(false);
    };

    let primaryButtonStyle = dangerous ? 'button-danger' : 'button-success';

    return (
        <Modal
            visible={visible}
            setVisible={setVisible}
            loading={loading}
            title={title ?? t('confirmation')}
            className={'max-w-lg'}
        >
            <div className={'text-gray-600 dark:text-gray-400 text-left text-base text-wrap'}>
                {question}
            </div>

            <div className={'flex mt-5 gap-1 justify-end'}>
                <Button
                    variant={'outline-red'}
                    className={'w-28'}
                    onClick={yesPressed}
                >
                    {t('yes')}
                </Button>
                <Button
                    variant={'outline-black'}
                    className={'w-28'}
                    onClick={noPressed}
                >
                    {t('no')}
                </Button>
            </div>
        </Modal>
    );
}
